import * as React from 'react';

import Chip from '@material-ui/core/Chip';

// só destaca o descarrego isento; os demais ficam sem marcação
const StatusField = ({ record }) =>
  record && record.isento ? (
    <Chip
      size="small"
      label="Isento"
      style={{ backgroundColor: '#fbc02d', fontWeight: 'bold' }}
    />
  ) : null;

export default StatusField;
